import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

type Props = {
  done: boolean;
  disabled?: boolean;
  onToggle: () => void;
};

/** Pipedrive-style circular done control. */
export default function ProjectActivityDoneToggle({
  done,
  disabled,
  onToggle,
}: Props) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      title={
        done
          ? t("project_activity_mark_undone", {
              defaultValue: "Mark as not done",
            })
          : t("project_activity_mark_done", { defaultValue: "Mark as done" })
      }
      aria-pressed={done}
      className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border transition-colors disabled:opacity-40 ${
        done
          ? "border-emerald-600 bg-emerald-600 text-white hover:bg-emerald-500"
          : "border-zinc-300 bg-white text-transparent hover:border-emerald-500 hover:text-emerald-500 dark:border-zinc-600 dark:bg-zinc-900"
      }`}
    >
      <Check className="h-3 w-3" strokeWidth={3} />
    </button>
  );
}
